import Pusher from 'pusher-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API_BASE_URL } from '../../screens/services/api.js';

let pusherInstance: Pusher | null = null;

const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY || '7961fffde701c4799572';
const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER || 'us2';

export const getPusher = async (): Promise<Pusher> => {
  if (pusherInstance) {
    console.log('[Pusher] Returning existing instance');
    return pusherInstance;
  }

  const token = await AsyncStorage.getItem('userToken');
  console.log('[Pusher] Initializing with key:', PUSHER_KEY, 'cluster:', PUSHER_CLUSTER);

  // In dev, surface the raw Pusher protocol (connection handshake, auth POSTs,
  // channel subscriptions, and every inbound event) in the console. This is the
  // fastest way to see whether a private-channel auth is failing or which event
  // name the backend actually broadcasts. No-op in production builds.
  if (typeof __DEV__ !== 'undefined' && __DEV__) {
    Pusher.logToConsole = true;
  }

  pusherInstance = new Pusher(PUSHER_KEY, {
    cluster: PUSHER_CLUSTER,
    forceTLS: true,
    // The unified auth endpoint is defined in routes/api.php as a POST+GET
    // route (`broadcasting.auth.unified`) — it lives under /api/, not /mobile/.
    // The /mobile/broadcasting/auth path Laravel auto-publishes is GET-only and
    // returns "POST method is not supported", breaking every private/presence
    // channel subscription on the web.
    authEndpoint: `${API_BASE_URL}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        Accept: 'application/json',
      },
    },
  });

  // Connection state logging
  pusherInstance.connection.bind('connected', () => {
    console.log('[Pusher] Connected successfully');
  });

  pusherInstance.connection.bind('disconnected', () => {
    console.log('[Pusher] Disconnected');
  });

  pusherInstance.connection.bind('error', (err: any) => {
    console.error('[Pusher] Connection error:', err);
  });

  return pusherInstance;
};

export const disconnectPusher = () => {
  if (pusherInstance) {
    console.log('[Pusher] Disconnecting');
    pusherInstance.disconnect();
    pusherInstance = null;
  }
};

export default {
  getPusher,
  disconnectPusher,
};